// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"675":"08ad99d7","748":"08ad99d7"}[chunkId] + ".chunk.css";
};